var render = function render(){var _vm=this,_c=_vm._self._c;return _c('content-page',{staticClass:"procedures",attrs:{"title":_vm.$t('procedures.title'),"loading":_vm.isLoading}},[_c('card-flex',{scopedSlots:_vm._u([{key:"after",fn:function(){return [_c('procedures-helper',{attrs:{"offer":_vm.currentOffer}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }